import { render, staticRenderFns } from "./ClockInDetail.vue?vue&type=template&id=87c33e60&scoped=true"
import script from "./ClockInDetail.vue?vue&type=script&lang=ts"
export * from "./ClockInDetail.vue?vue&type=script&lang=ts"
import style0 from "./ClockInDetail.vue?vue&type=style&index=0&id=87c33e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c33e60",
  null
  
)

export default component.exports